import { render, staticRenderFns } from "./banner2.vue?vue&type=template&id=0281766d&scoped=true&"
import script from "./banner2.vue?vue&type=script&lang=js&"
export * from "./banner2.vue?vue&type=script&lang=js&"
import style0 from "./banner2.vue?vue&type=style&index=0&id=0281766d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0281766d",
  null
  
)

export default component.exports